import * as React from 'react';

import './Quiz.css';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getQuiz } from '../../store/ducks/quiz/actions';
import { quizSelector } from '../../store/ducks/quiz/selectors/quizSelector';
import { QuizState } from 'store/ducks/quiz/types';
import cn from 'classnames';
import { Share } from '../../components/Share/Share';
import { Loading } from '../../components/UI/Loading/Loading';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import {
    Link,
    Button,
    Element,
    Events,
    animateScroll as scroll,
    scrollSpy,
    scroller,
} from 'react-scroll';
import { Helmet } from 'react-helmet';
import { domainName } from '../../config';
import { useLocation, useHistory } from 'react-router-dom';
type Props = {
    quiz: any;
};

export default function Quiz(props: Props) {
    const { quiz } = props;

    const { slug, category }: { slug: string; category: string } = useParams();

    const { pathname } = useLocation();
    const history = useHistory();
    const params = Number(history.location.search.replace(/[^0-9]/g, ''));

    const status = useSelector((state: QuizState) => state.quiz.status);

    const [startGame, setStartGame] = useState(false);
    const [resultGame, setResultGame] = useState(false);
    const [currentCard, setCurrentCard] = useState(1);
    const [btnFalse, setBtnFalse] = useState(null);
    const [btnTrue, setBtnTrue] = useState(null);
    const [btnDisable, setBtnDisable] = useState(true);
    const [countTrue, setCountTrue] = useState(0);
    const [helmetContent, setHelmetContent] = useState(null);

    const resultCard = (answer: boolean) => {
        if (btnDisable) {
            if (answer === true) {
                setBtnFalse('red');
                setBtnTrue('green-long');
                setCountTrue(countTrue + 1);
            } else {
                setBtnFalse('red-long');
                setBtnTrue('green');
            }
        }

        setBtnDisable(false);
    };

    const nextCard = () => {
        setBtnFalse(null);
        setBtnTrue(null);
        setBtnDisable(true);

        if (currentCard < quiz.questions.length) {
            setCurrentCard(currentCard + 1);
        } else {
            setStartGame(false);
            setResultGame(true);
            setUrl();
        }
    };

    const endGame = () => {
        setResultGame(false);
        setStartGame(false);
        setCurrentCard(1);
        setCountTrue(0);
    };

    const setUrl = () => {
        let i = 0;

        for (let e of quiz.resultScreen.resultList) {
            i++;

            if (
                countTrue >= e.test_result_number.test_result_first_num &&
                countTrue <= e.test_result_number.test_result_last_num
            ) {
                // window.history.pushState(
                //     '',
                //     '',
                //    `?r${i}`
                // );

                setHelmetContent({
                    desc: e.test_result_subtitle,
                    img: e.test_result_share_img,
                    url: `https://${domainName}${pathname}?r=${i}`,
                });
            }
        }
    };

    useEffect(() => {
        if (quiz && history.location.search) {
            setUrl2(params);
        }
    }, [quiz]);

    const setUrl2 = (num: number) => {
        if (num > 0 && num <= quiz.resultScreen.resultList.length) {
            setHelmetContent({
                desc:
                    quiz.resultScreen.resultList[num - 1].test_result_subtitle,
                img:
                    quiz.resultScreen.resultList[num - 1].test_result_share_img,
                url: `https://${domainName}${pathname}?r=${num}`,
            });
        }
    };

    if (status === 'LOADING' || !quiz) return <Loading />;

    return (
        <>
            {helmetContent && (
                <>
                    <Helmet>
                        <meta
                            property="og:description"
                            content={helmetContent.desc}
                        />
                        <meta
                            property="twitter:description"
                            content={helmetContent.desc}
                        />
                        <meta property="og:image" content={helmetContent.img} />
                        <meta property="og:url" content={helmetContent.url} />
                    </Helmet>
                </>
            )}

            <main className="page">
                <Element
                    className={cn('quiz', startGame && '_start-game')}
                    name="question"
                >
                    {!startGame && !resultGame && (
                        <>
                            <div className="quiz__bg">
                                {/* <source
                                        srcSet="/img/quiz-fs-mob.jpg"
                                        media="(max-width: 768px) "
                                    /> */}
                                <img
                                    src={
                                        quiz.firstScreen && quiz.firstScreen.bg
                                    }
                                    alt="bg"
                                />

                                <div
                                    className="quiz__photo-credit"
                                    dangerouslySetInnerHTML={{
                                        __html: quiz.firstScreen.author,
                                    }}
                                ></div>
                            </div>
                            <div className="quiz__first-screen">
                                <div className="quiz__wrap">
                                    <div className="quiz__tag">тесты</div>
                                    <div className="quiz__date">
                                        {quiz.firstScreen.date}
                                    </div>
                                </div>
                                <h1
                                    className="quiz__title"
                                    dangerouslySetInnerHTML={{
                                        __html: quiz.firstScreen.title,
                                    }}
                                ></h1>
                                <p
                                    className="quiz__text"
                                    dangerouslySetInnerHTML={{
                                        __html: quiz.firstScreen.subtitle,
                                    }}
                                ></p>
                                <Link
                                    className="quiz__btn"
                                    onClick={() => setStartGame(true)}
                                    to="question"
                                    // spy={true}
                                    // smooth={true}
                                    // duration={500}
                                >
                                    пройти тест
                                </Link>
                            </div>
                        </>
                    )}
                    {startGame && (
                        <div className="quiz-card quiz__card">
                            <div className="quiz-card__number">
                                {currentCard} / {quiz.questions.length}
                            </div>
                            <div
                                className="quiz-card__title"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        quiz.questions[currentCard - 1]
                                            .test_card_title,
                                }}
                            ></div>
                            <div className="quiz-card__img">
                                <img
                                    src={
                                        quiz.questions[currentCard - 1]
                                            .test_card_img
                                    }
                                    alt="img"
                                />
                            </div>
                            <div className="quiz-card__credit">
                                {
                                    quiz.questions[currentCard - 1]
                                        .test_card_img_credit
                                }
                            </div>
                            {quiz.questions[
                                currentCard - 1
                            ].test_card_answer_list.map((e: any) => {
                                if (e.test_card_true === 'false') {
                                    return (
                                        <div
                                            className={cn(
                                                'quiz-card__btn',
                                                (btnFalse === 'green' ||
                                                    btnFalse ===
                                                        'green-long') &&
                                                    '_green',
                                                (btnFalse === 'red' ||
                                                    btnFalse === 'red-long') &&
                                                    '_red'
                                            )}
                                            onClick={() => resultCard(false)}
                                        >
                                            <div className="quiz-card__btn-title">
                                                {e.test_card_text_btn}
                                            </div>
                                            {(btnFalse === 'green-long' ||
                                                btnFalse === 'red-long') && (
                                                <div className="quiz-card__btn-text">
                                                    <p
                                                        className={cn(
                                                            btnFalse ===
                                                                'green-long' &&
                                                                '_green-long',
                                                            btnFalse ===
                                                                'red-long' &&
                                                                '_red-long'
                                                        )}
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                e.test_card_answer,
                                                        }}
                                                    ></p>
                                                </div>
                                            )}
                                        </div>
                                    );
                                } else if (e.test_card_true === 'true') {
                                    return (
                                        <div
                                            className={cn(
                                                'quiz-card__btn',
                                                (btnTrue === 'green' ||
                                                    btnTrue === 'green-long') &&
                                                    '_green',
                                                (btnTrue === 'red' ||
                                                    btnTrue === 'red-long') &&
                                                    '_red'
                                            )}
                                            onClick={() => resultCard(true)}
                                        >
                                            <div className="quiz-card__btn-title">
                                                {e.test_card_text_btn}
                                            </div>
                                            {(btnTrue === 'green-long' ||
                                                btnTrue === 'red-long') && (
                                                <div className="quiz-card__btn-text">
                                                    <p
                                                        className={cn(
                                                            btnTrue ===
                                                                'green-long' &&
                                                                '_green-long',
                                                            btnTrue ===
                                                                'red-long' &&
                                                                '_red-long'
                                                        )}
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                e.test_card_answer,
                                                        }}
                                                    ></p>
                                                </div>
                                            )}
                                        </div>
                                    );
                                }
                            })}

                            {!btnDisable && (
                                <Link
                                    className="quiz-card__btn-next"
                                    onClick={nextCard}
                                    to="question"
                                    // spy={true}
                                    // smooth={true}
                                    // duration={500}
                                >
                                    дальше
                                </Link>
                            )}
                        </div>
                    )}
                    {resultGame && (
                        <>
                            <div className="quiz__bg">
                                {/* <source
                                        srcSet="/img/result-game-mob.jpg"
                                        media="(max-width: 768px) "
                                    /> */}
                                <img
                                    src={
                                        quiz.resultScreen &&
                                        quiz.resultScreen.bg
                                    }
                                    alt="bg"
                                />

                                <div className="quiz__photo-credit"></div>
                            </div>
                            <div className="quiz-result page__quiz-result">
                                {quiz.resultScreen.resultList.map((e: any) => {
                                    if (
                                        countTrue >=
                                            e.test_result_number
                                                .test_result_first_num &&
                                        countTrue <=
                                            e.test_result_number
                                                .test_result_last_num
                                    ) {
                                        return (
                                            <>
                                                <div className="quiz-result__header">
                                                    <div className="quiz-result__number">
                                                        верно {countTrue}/
                                                        {quiz.questions.length}
                                                    </div>
                                                    <div
                                                        className="quiz-result__status"
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                e.test_result_title,
                                                        }}
                                                    ></div>
                                                </div>
                                                <div
                                                    className="quiz-result__text"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            e.test_result_subtitle,
                                                    }}
                                                ></div>
                                            </>
                                        );
                                    }
                                })}
                                <div className="quiz-result__wrap">
                                    <Share
                                        debug
                                        mod="quiz"
                                        url={helmetContent.url}
                                    />
                                    <a
                                        href="#"
                                        className="quiz-result__refresh"
                                        onClick={endGame}
                                    >
                                        Пройти ещё раз
                                    </a>
                                </div>
                            </div>
                        </>
                    )}
                </Element>
            </main>
        </>
    );
}
